export { staticTable } from "#static-table";
